"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CTAButton = props => {
  if ((0, _lodash.isEmpty)(props.label)) return null;
  var variant = (0, _lodash.get)(props, 'buttonType', 'primary');
  var args = {
    variant: variant
  };
  if (props.onClick) {
    args.onClick = () => props.onClick();
  }
  if (!(0, _lodash.isEmpty)(props.href)) {
    args.href = props.href;
    args.target = props.target;
    if (!(0, _lodash.isEmpty)(props.linkAlt)) args.title = props.linkAlt;
  }
  var ButtonContent = () => {
    if (props.iconDirection === 'left') {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _lodash.isEmpty)(props.icon) && /*#__PURE__*/_react.default.createElement("span", {
        className: props.icon
      }), /*#__PURE__*/_react.default.createElement("span", null, props.label));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, props.label), !(0, _lodash.isEmpty)(props.icon) && /*#__PURE__*/_react.default.createElement("span", {
        className: props.icon
      }));
    }
  };
  if ((0, _lodash.isEmpty)(props.dataId)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, args, /*#__PURE__*/_react.default.createElement(ButtonContent, null)));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, _extends({}, args, {
      "cta-data-id": (0, _lodash.toLower)(props.dataId)
    }), /*#__PURE__*/_react.default.createElement(ButtonContent, null)));
  }
};
CTAButton.propTypes = {
  buttonType: _propTypes.default.oneOf(['link', 'primary', 'secondary', 'inline']),
  href: _propTypes.default.string,
  label: _propTypes.default.string,
  dataId: _propTypes.default.string,
  linkAlt: _propTypes.default.string,
  target: _propTypes.default.string,
  icon: _propTypes.default.string,
  iconDirection: _propTypes.default.oneOf(['left', 'right', '']),
  onClick: _propTypes.default.func
};
var _default = exports.default = CTAButton;